import { DomNewSiteRedirectRoute } from './dom-new-site-redirect.interfaces';

/** GrowthBook JSON string[]: city slug и/или alias ТК, напр. ["saratov","1545"]. */
export const WEB_DOM_NEW_SITE_CITIES_FEATURE_KEY: string = 'web_dom_new_site_cities';
export const DOM_NEW_SITE_URL: string = 'https://new.domlenta.ru';
export const DOM_NEW_SITE_HOSTNAME: string = 'new.domlenta.ru';

/** WEB-2164: город + ТК → region_id нового сайта ДомЛенты */
export const DOM_NEW_SITE_REDIRECT_ROUTES: DomNewSiteRedirectRoute[] = [
  {
    citySlug: 'moscow',
    storeAliases: ['1501', '1506', '1513', '1509', '1531', '1537', '1539', '1535'],
    regionId: 1,
  },
  {
    citySlug: 'spb',
    storeAliases: ['1505', '1507', '1514', '1515', '1516', '1590'],
    regionId: 30,
  },
  {
    citySlug: 'nnov',
    storeAliases: ['1511', '1517'],
    regionId: 24,
  },
  {
    citySlug: 'ekb',
    storeAliases: ['1512', '1519'],
    regionId: 42,
  },
  {
    // В region/list отдельного slug нет — allow/resolve по alias ТК в GB ("1545").
    citySlug: 'stupino',
    storeAliases: ['1545'],
    regionId: 86,
  },
  {
    citySlug: 'kzn',
    storeAliases: ['1508'],
    regionId: 20,
  },
  {
    citySlug: 'bryansk',
    storeAliases: ['1542'],
    regionId: 3,
  },
  {
    citySlug: 'volgograd',
    storeAliases: ['1523'],
    regionId: 53,
  },
  {
    citySlug: 'ksdr',
    storeAliases: ['1530'],
    regionId: 51,
  },
  {
    citySlug: 'saratov',
    storeAliases: ['1534'],
    regionId: 28,
  },
  {
    citySlug: 'ryazan',
    storeAliases: ['1533'],
    regionId: 13,
  },
  {
    citySlug: 'tula',
    storeAliases: ['1543'],
    regionId: 84,
  },
];
